export default __webpack_public_path__ + "static/media/Icon.6fdc2be8.png";